export function PressPage() {
  return (
    <main className="press-page">
      <a className="press-home" href="/">← aviyashchin.com</a>
      <h1>Press Kit</h1>
      <p className="press-lede">Avi Yashchin — Founder &amp; CEO, Subconscious.ai. Bios below are cleared for use as-is.</p>

      <section>
        <h2>Bio — short</h2>
        <p>Avi Yashchin is the founder and CEO of Subconscious.ai, building AI systems that explain and predict human behavior.</p>
      </section>

      <section>
        <h2>Bio — medium</h2>
        <p>Avi Yashchin is the founder and CEO of Subconscious.ai, where he builds autonomous research systems that simulate human decision-making for product, pricing, and policy questions. Previously a product leader at Two Sigma and IBM Watson Research, he has founded and exited two companies, acquired by CleanSpark and Kaplan.</p>
      </section>

      <section>
        <h2>Bio — long</h2>
        <p>Avi Yashchin is the founder and CEO of Subconscious.ai, which builds AI systems that explain and predict human behavior by running randomized experiments on synthetic populations. Before Subconscious he led machine-learning product work at Two Sigma — including catastrophe-bond analytics and structured insurance risk — and turned IBM Watson research into commercial AI products for banking and education. He has founded and exited two companies: WAHA Technologies, a zero-carbon high-performance-computing data-center business acquired by CleanSpark (NASDAQ: CLSK), and CleanEdison, a green-jobs training provider that trained more than 20,000 students, acquired by Kaplan (Graham Holdings, NYSE: GHC). He holds a BS in Computer Science from Johns Hopkins and an MBA from NYU Stern.</p>
      </section>

      <section>
        <h2>About Subconscious.ai</h2>
        <p>Subconscious.ai builds autonomous research systems that simulate human decision-making. By running randomized controlled experiments on AI-generated synthetic populations calibrated against real human data, Subconscious delivers causal insight into product, pricing, and policy questions in minutes rather than months. Based in New York City.</p>
      </section>

      <section>
        <h2>Assets</h2>
        <p><a href="/og-image.png" download>Download social image (PNG)</a>. High-resolution headshot and Subconscious.ai logo available on request.</p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>
          <a href="mailto:avi+home@subconscious.ai">avi+home@subconscious.ai</a> ·{" "}
          <a href="https://calendly.com/aviyashchin" target="_blank" rel="noopener noreferrer">Calendly</a> ·{" "}
          <a href="https://www.linkedin.com/in/aviyashchin/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        </p>
      </section>
    </main>
  )
}
